module.exports = __webpack_public_path__ + "img/b_s_s.c9624821.jpg";